import { useAtom } from "jotai";
import { backendDataAtom } from "atoms/backendDataAtom.js";
import { backendPatch } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";

export function useInsurerActions() {
  const [backendData, setBackendData] = useAtom(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state =
    backendData?.type === "insurer-list"
      ? backendData
      : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "insurer-list",
      data: data,
    });
  };

  const updateMaxMailSize = async (insurer_id, form_data) => {
    return await backendPatch(`data/insurers/${insurer_id}/max-mail-size`, {
      label: "Maximale Mailgröße der Versicherungsgesellschaft",
      toSend: form_data,
      enqueueSnackbar,
      successMessage: "Maximale Mailgröße wurde aktualisiert.",
      setResult: (res) => {
        const updated_insurer = res?.data ?? res;
        updateListItemState(backendData, setBackendData, updated_insurer);
      },
    });
  };

  return {
    updateMaxMailSize,
    setState,
    state,
  };
}
